import * as React from 'react';
import RcSwitch from 'rc-switch';
import classNames from 'classnames';
import omit from 'omit.js';
import Loading from '../icon/Loading';
import Wave from '../_util/wave';
import { ConfigContext } from '../config-provider';
import SizeContext from '../config-provider/SizeContext';
import warning from '../_util/warning';
const Switch = React.forwardRef((props, ref) => {
    warning('checked' in props || !('value' in props), 'Switch', '`value` is not a valid prop, do you mean `checked`?');
    const { prefixCls: customizePrefixCls, size: customizeSize, loading, className = '', disabled, } = props;
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const size = React.useContext(SizeContext) || 'small';
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    const loadingIcon = loading ? <Loading className={`${prefixCls}-loading-icon`}/> : null;
    const classes = classNames(className, {
        [`${prefixCls}-small`]: (customizeSize || size) === 'small',
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-rtl`]: direction === 'rtl',
    });
    return (<Wave insertExtraNode>
      <RcSwitch {...omit(props, ['loading'])} prefixCls={prefixCls} className={classes} disabled={disabled || loading} ref={ref} loadingIcon={loadingIcon}/>
    </Wave>);
});
Switch.__ANT_SWITCH = true;
export default Switch;
